<template>
    <div class="preview-mask" v-show="show">
        <div class="content" ref="content">
            <img :src="src" width="100%" :height="imgHeight">
        <div class="close" @click="close">
            <i class="mint-toast-icon mintui mintui-field-error" style="font-size:50px;color:white;"></i>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        value:{},
        src:{
            type:String,
            default:"",
        }
    },
    created(){
        this.show=this.value;
    },
    mounted(){
        var self = this;
            var img_url =this.src
            var img = new Image()
            img.src=img_url
            var contentWidth=this.$refs.content.clientWidth;
            var contentHeight=this.$refs.content.clientHeight;
            var imgHeight = Math.ceil(img.height/img.width * contentWidth);
            if(imgHeight>contentHeight){
                this.imgHeight=contentHeight;
            }else{
                this.imgHeight=imgHeight;
            }
    },
    data(){
        return{
            show:false,
            imgHeight:0,
        }
    },
    methods:{
        getImgSize(src){
            
        },
        close(){
            this.show=false;
            this.$emit("bindClose")
        }
    }
}
</script>

<style scoped>
.preview-mask{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    width: 100vw;
    height: 100%;
}
.content{
    position: relative;
    width: 100%;
    height: 80%;
    /* display: table; */
    display: flex;
    justify-content: center;
    align-items: center;
}
/* .content img{
    object-fit: cover;
    object-position: center;
    max-height: 100%;
} */
.close{
    position: absolute;
    top:-60px;
    right: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/preview.vue